/**
 * In-memory ring buffer fallback.
 * When CloudWatch writes fail, events are buffered here for retry
 * on the next successful flush. Never touches localStorage or disk.
 */

import type { LogEvent } from '../types';

const MAX_IN_MEMORY_EVENTS = 50;

export class FallbackBuffer {
  private buffer: LogEvent[] = [];

  /** Store events in the in-memory ring buffer for later retry. */
  store(events: LogEvent[]): void {
    this.buffer = [...this.buffer, ...events].slice(-MAX_IN_MEMORY_EVENTS);
  }

  /** Retrieve buffered events. Returns a copy. */
  retrieve(): LogEvent[] {
    return [...this.buffer];
  }

  /** Clear all buffered events. */
  clear(): void {
    this.buffer = [];
  }
}
